import { useCallback, useEffect, useState } from 'react';
import { api } from '../lib/api';

export interface WinMatch { id: string; title: string; detail: string; points: number; winnerTeamId: string | null }
export interface WinTeam { id: string; name: string; color: string; points: number; matchPoints: number; challengePointsEarned: number }
export interface WinStand { matches: WinMatch[]; teams: WinTeam[]; challengePointsEnabled: boolean; challengePoints: number; results: {runId:string;teamId:string;passed:boolean}[] }

export function WinPunktetafel({ lobbyId }: { lobbyId: string }) {
  const [stand, setStand] = useState<WinStand | null>(null);
  const [titel, setTitel] = useState('');
  const [detail, setDetail] = useState('');
  const [punkte, setPunkte] = useState(1);
  const [fehler, setFehler] = useState('');
  const [busy, setBusy] = useState(false);
  const laden = useCallback(async () => { setStand(await api.winMatches(lobbyId)); }, [lobbyId]);
  useEffect(() => { void laden().catch(err => setFehler(String(err))); }, [laden]);
  async function tun(fn: () => Promise<unknown>) {
    setBusy(true); setFehler('');
    try { await fn(); await laden(); }
    catch (err) { setFehler(err instanceof Error ? err.message : 'Aktion fehlgeschlagen.'); }
    finally { setBusy(false); }
  }
  return <section className="panel">
    <h2>Win-Challenge · Gesamtpunktetafel</h2>
    <p className="muted small">Nur Matches mit festgelegtem Gewinner vergeben Punkte. Eine Gewinnerkorrektur berechnet die Teamwertung automatisch neu.</p>
    <div className="row">{stand?.teams.map(team => <div key={team.id} style={{ padding: '0.7rem', borderLeft: `4px solid ${team.color}` }}><strong>{team.name}</strong> · {team.points} Punkte <small className="muted">(Matches: {team.matchPoints}, Challenges: {team.challengePointsEarned})</small></div>)}</div>
    <h3>Matches</h3>
    {stand?.matches.map((match, i) => <div key={match.id} className="row" style={{ marginBottom: '0.6rem', gap: '0.6rem' }}>
      <span style={{ flex: 1 }}>{i + 1}. <strong>{match.title}</strong> · {match.detail} · {match.points} Punkte</span>
      <label>Gewinner
        <select disabled={busy} value={match.winnerTeamId ?? ''} onChange={event => void tun(() => api.winMatchÄndern(lobbyId, match.id, { winnerTeamId: event.target.value || null }))}>
          <option value="">Noch offen</option>
          {stand.teams.map(team => <option key={team.id} value={team.id}>{team.name}</option>)}
        </select>
      </label>
      <button type="button" className="ghost" disabled={busy} onClick={() => {
        const title = window.prompt('Matchname', match.title);
        if (title === null) return;
        const d = window.prompt('Runden oder Dauer', match.detail);
        if (d === null) return;
        const p = window.prompt('Punkte', String(match.points));
        if (p === null) return;
        const n = Number(p);
        if (!Number.isInteger(n) || n < 0 || n > 100000) { setFehler('Ungültige Punktezahl.'); return; }
        void tun(() => api.winMatchÄndern(lobbyId, match.id, { title, detail: d, points: n }));
      }}>Bearbeiten</button>
      <button type="button" className="ghost" disabled={busy} onClick={() => { if (window.confirm(`Match „${match.title}“ löschen?`)) void tun(() => api.winMatchLöschen(lobbyId, match.id)); }}>Löschen</button>
    </div>)}
    <form onSubmit={event => { event.preventDefault(); void tun(async () => { await api.winMatchAnlegen(lobbyId, { title: titel, detail, points: punkte }); setTitel(''); setDetail(''); }); }}>
      <h3>Neues Match</h3>
      <div className="row">
        <label>Spiel / Aufgabe<input required maxLength={120} value={titel} onChange={event => setTitel(event.target.value)} placeholder="Move or Die" /></label>
        <label>Runden / Zeit<input maxLength={100} value={detail} onChange={event => setDetail(event.target.value)} placeholder="7 Runden / 90 Minuten" /></label>
        <label>Punkte<input type="number" min="0" max="100000" value={punkte} onChange={event => setPunkte(Number(event.target.value))} /></label>
        <button disabled={busy} type="submit">Match hinzufügen</button>
      </div>
    </form>
    {fehler && <p role="alert" className="notice">{fehler}</p>}
  </section>;
}
